import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Title,
  Text,
  Image,
  Group,
  Center,
  Tabs,
  Divider,
  useMantineTheme,
} from '@mantine/core';

import * as classes from './CardsBlock.module.css';
import ButtonBlock from '../ButtonBlock';


function CardsBlock({
  description,
  title,
  buttons,
  cards,
  stile,
}) {
  const { colors } = useMantineTheme();

  return (
    <Container size="lg" py="sm" fluid style={{ backgroundColor: stile?.coloreDiSfondo ? colors[stile?.coloreDiSfondo][1] : 'inherit' }}>
      <Container>
        {title && (
          <Title order={3} className={classes.title} ta="center" mt="sm">
            {title}
          </Title>
        )}

        {description && (
          <>
            <Text className={classes.description} ta="center" mt="md">
              {description}
            </Text>
            <Divider color={`${stile?.coloreDiSfondo}.7`} size="sm" mt="sm" className={classes.separator} />
          </>
        )}

        <Container mb="xl" pl={0} pr={0} mt="xl">
          <Tabs radius="xs" orientation="vertical" defaultValue="card_0">
            <Tabs.List size="lg">
              {cards.map(({ blockCardTitle }, key) => (
                <Tabs.Tab value={`card_${key}`} key={`title_${key}`}>
                  <Text hiddenFrom="md" span>{key + 1}</Text>
                  <Text visibleFrom="md" span>{blockCardTitle}</Text>
                </Tabs.Tab>
              ))}
            </Tabs.List>

            {cards.map(({
              blockCardTitle,
              blockCardImage: { title, alt, url },
              blockCardDescription
            }, key) => (
              <Tabs.Panel
                value={`card_${key}`}
                key={`card_${key}`}
                p="xl"
                pt={0}
                pb={0}
                className={classes.panel}
              >
                <Image
                  className={classes.image}
                  title={title}
                  alt={alt}
                  src={url}
                  fit="contain"
                  radius="md"
                />
                <Group justify="space-between" mb="md" hiddenFrom="md" className={classes.cardDescr}>
                  <Text ta="center" style={{ width: '100%' }} fw={500}>{blockCardTitle}</Text>
                </Group>

                <Text c="dimmed" dangerouslySetInnerHTML={{ __html: blockCardDescription }} />
              </Tabs.Panel>
            ))}
          </Tabs>

          {!!buttons?.length && (
            <Center mt="md" mb="xl">
              <ButtonBlock buttons={buttons} />
            </Center>
          )}
        </Container>
      </Container>
    </Container>
  );
}

CardsBlock.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttons: PropTypes.array,
  cards: PropTypes.array,
};

export default CardsBlock;
